import { Component, Prop } from 'vue-property-decorator';
import { changeNumberFormat, applyNumberFixed } from '@/assets/common/services'
import { AbstractWidgetContent } from '@/components/Dashboard/Widgets/AbstractWidget/AbstractWidget';
import { WidgetConfigIncomeAndOutgoAgriFieldGroup, WidgetData } from '@/components/Dashboard/Widgets/types/Widget';
import IncomeAndOutgoChart from '@/components/IncomeAndOutgo/IncomeAndOutgoChart/IncomeAndOutgoChart.vue'
import moment from 'moment';
import { toCamel } from 'snake-camel';
import { AgriFieldIncomeOutgo } from '@/types/Component';

type IncomeAndOutgoItem = {
    agriFieldName: string;
    income: number;
    outgo: number;
    incomeAndOutgo: number;
}

@Component({
    components: { IncomeAndOutgoChart },
    filters: {
        applyNumberFixed,
        changeNumberFormat,
    }
})
export default class WidgetContentIncomeAndOutgoAgriFieldGroupPart extends AbstractWidgetContent<WidgetConfigIncomeAndOutgoAgriFieldGroup> {
    private incomeAndOutgoItems: IncomeAndOutgoItem[] = []
    private isTable = true
    private existAgriFieldGroup = true
    @Prop()
    public config!: WidgetConfigIncomeAndOutgoAgriFieldGroup;

    private startDate = ''
    private endDate = ''

    created(): void {
        this.updateDate()
        this.getIncomeAndOutgo()
    }

    refresh(widgetData: WidgetData): void {
        if(typeof widgetData == 'object') {
            this.$set(this.config, 'startDate', widgetData.config.startDate)
            this.$set(this.config, 'endDate', widgetData.config.endDate)
            this.$set(this.config, 'agriFieldGroup', widgetData.config.agriFieldGroup)
        }
        this.updateDate()
        this.getIncomeAndOutgo()
    }

    private updateDate() {
        this.startDate = moment(this.config.startDate).format('YYYY年M月D日')
        this.endDate = this.config.endDate
            ? moment(this.config.endDate).format('YYYY年M月D日')
            : '現在'
    }

    private getIncomeAndOutgo() {
        const groupId = this.config.agriFieldGroup
        const startDate = this.config.startDate
        const endDate = this.config.endDate ? this.config.endDate : moment().format('YYYY-MM-DD')
        const uri = `/admin/income_and_outgo/agri_field_groups/${groupId}?start_date=${startDate}&end_date=${endDate}`
        this.$apiClient.doRequest('get', uri)
            .then((res: AgriFieldIncomeOutgo) => {
                this.incomeAndOutgoItems = res.outlines.map(af => toCamel(af)) as IncomeAndOutgoItem[]
            })
            .catch(err => {
                this.existAgriFieldGroup = err.status !== 404
            })
    }

    private changeChartView(isTable: boolean) {
        this.isTable = isTable
    }
}
